<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="./"
        >รับสมัครนักศึกษาประจำปีการศึกษา {{ this.getDataFrom.select_year }}</a
      >
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>
        <li class="nav-item">
          <a
            id="myLink"
            class="nav-link"
            aria-current="page"
            @click="checkCondition()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep1 == 'active'"
            />
            LOGIN
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            @click="SetStepStatus2()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep2 == 'active'"
            />
            ขั้นตอนที่ 1</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            @click="SetStepStatus3()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep3 == 'active'"
            />
            ขั้นตอนที่ 2</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            @click="SetStepStatus4()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep4 == 'active'"
            />
            ขั้นตอนที่ 3</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            @click="SetStepStatus5()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep5 == 'active'"
            />
            ขั้นตอนที่ 4</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            @click="SetStepStatus6()"
            style="cursor: pointer"
          >
            <font-awesome-icon
              :icon="['fas', 'circle-dot']"
              style="color: red"
              v-if="this.getNavBarActive.ActiveStep6 == 'active'"
            />
            ขั้นตอนที่ 5</a
          >
        </li>
      </div>
    </div>
  </nav>
  <!-- <div class="bg-primary">{{ this.getNavBarActive }}</div> -->
</template>

<script>
import { mapGetters } from "vuex";
import swal from "sweetalert2";
export default {
  name: "NavbarStep",
  props: {
    msg: String,
  },
  data() {
    return {
      conditionIsMet: "",
    };
  },
  async mounted() {},
  methods: {
    async checkCondition() {
      const result = await swal.fire({
        icon: "warning",
        title: "กลับไปหน้า Login",
        text: "หากต้องการกลับไปหน้า Login กด Yes ถ้าไม่ กด No",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });
      // ตรวจสอบเงื่อนไขที่นี่\
      if (result.isConfirmed) {
        // ถ้าเงื่อนไขผ่าน ให้กำหนด URL ที่ต้องการใน href
        window.location.reload();
        // this.getDataFrom.stu_sms_stu = "";
        // this.getDataFrom.stu_card_id = "";
        // this.$store.dispatch("Main/SetStepStatus", 1);
      } else if (result.isDismissed) {
        // ถ้าเงื่อนไขไม่ผ่าน ให้กำหนด URL ที่ต้องการอื่น ๆ
      }
    },
    async SetStepStatus2() {
      this.$store.dispatch("Main/SetStepStatus", 2);
    },
    async SetStepStatus3() {
      this.$store.dispatch("Main/SetStepStatus", 3);
    },
    async SetStepStatus4() {
      this.$store.dispatch("Main/SetStepStatus", 4);
    },
    async SetStepStatus5() {
      this.$store.dispatch("Main/SetStepStatus", 5);
    },
    async SetStepStatus6() {
      this.$store.dispatch("Main/SetStepStatus", 6);
    },
  },
  computed: {
    ...mapGetters({
      getAdmissionYear: "Main/_getAdmissionYear",
      getStepIndex: "Main/_getStepIndex",
      getNavBarActive: "Main/_getNavBarActive",
      getDataFrom: "Step1/_getDataFrom",
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
